import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p>Villamix Express • ofertas, hortifruti e reposição</p>
      <span>Tecnologia e integração por <strong>IGS Automação Comercial</strong></span>
    </footer>
  );
}
